import { render, staticRenderFns } from "./MyFutureWellbeing.vue?vue&type=template&id=cce399b0&scoped=true"
import script from "./MyFutureWellbeing.vue?vue&type=script&lang=js"
export * from "./MyFutureWellbeing.vue?vue&type=script&lang=js"
import style0 from "./MyFutureWellbeing.vue?vue&type=style&index=0&id=cce399b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce399b0",
  null
  
)

export default component.exports